export const RECEIVE_SERVER_MESSAGE = "RECEIVE_SERVER_MESSAGE";
export const DISMISS_SERVER_MESSAGE = "DISMISS_SERVER_MESSAGE";
export const RESET_SERVER_MESSAGE = "RESET_SERVER_MESSAGE";

export const resetServerMessage = () => ({
  type: RESET_SERVER_MESSAGE,
});

export const receiveServerMessage = (message) => ({
  type: RECEIVE_SERVER_MESSAGE,
  message,
});

export const dismissServerMessage = (message) => ({
  type: DISMISS_SERVER_MESSAGE,
  message,
});
